import { queryOptions } from '@tanstack/react-query';

import type { BackendTypes } from '@tf/api';
import { BackendClient } from '@tf/api';
import { splitObjectId } from '@tf/utils';

// TODO: use it everywhere (TF & CA)

export const objectUriByNodeIdQueryOptions = (nodeId: BackendTypes.GraphId) => {
	return queryOptions({
		queryKey: ['objectUriByNodeId', nodeId],
		queryFn: async (): Promise<string> => {
			const res = await BackendClient.getInstance().legacyObjectUriByNodeId({ nodeId: nodeId });
			return res.json();
		},
		// Object ID will not change (only the version changes), so we can cache value forever for the next resolves with the same nodeId
		staleTime: Infinity,
	});
};

export const formObjectUriBySegmentIdentityQueryOptions = (segmentIdentity: BackendTypes.SegmentIdentity) => {
	return queryOptions({
		queryKey: ['formObjectUriBySegmentIdentity', segmentIdentity],
		queryFn: async (): Promise<string> => {
			const res = await BackendClient.getInstance().legacyObjectUriBySegmentIdentity(segmentIdentity);
			return res.json();
		},
		staleTime: Infinity,
	});
};

export const nodeIdByObjectUriQueryOptions = (objectId: string) => {
	return queryOptions({
		queryKey: ['nodeIdByObjectUri', objectId],
		queryFn: async (): Promise<BackendTypes.GraphId> => {
			const { objectName } = splitObjectId(objectId);
			const res = await BackendClient.getInstance().legacyNodeIdByObjectUri({ objectName: objectName });
			return res.json();
		},
		staleTime: Infinity,
	});
};
